<div class="wrapper-alert" [class.on-close]="isClosed" *ngIf="isShowAlert">
	<div class="message" [class]="'message-' + typeAlert">
		<ng-content select="[title]"></ng-content>
		<button type="button" (click)="closeAlert()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</div>
